// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"122":"5fe7a7af","213":"7fdfebd6","228":"089d576f","510":"a0d878a4","813":"ba981198","938":"4853ea75"}[chunkId] + ".chunk.js";
};